/** Desktop Kai history column — sidebar and layout grid must stay in sync. */
export const kaiHistorySidebarWidthClass = "w-[min(18rem,24vw)]";

/**
 * history | chat | balance — the right column is wider than the history column
 * by the icon-rail gutter + shell gap (both sit outside this grid) so the
 * thread’s max-width box lines up with the viewport-centered top bar.
 */
export const kaiChatPageGridClass =
  "lg:grid lg:grid-cols-[min(18rem,24vw)_minmax(0,1fr)_calc(min(18rem,24vw)+var(--rail-gutter-width)+var(--shell-gap))]";
